import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './AdvisorPanel_Settings.scss';
import { _className } from '@nu-art/thunderstorm-frontend/index';
import { AdvisorPanel } from '../AdvisorPanel/AdvisorPanel.js';
import { PanelKey_Settings } from '../../../_shared.js';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { ICONS } from '@app/styles';
import { Component_LiveMDMButton } from '../../components/home-panel/Component_LiveMDMButton/Component_LiveMDMButton.js';
import { Component_EventFeedButton } from '../../components/home-panel/Component_EventFeedButton/Component_EventFeedButton.js';
export class AdvisorPanel_Settings extends AdvisorPanel {
    //######################### Static #########################
    static defaultProps = {
        panelKey: PanelKey_Settings,
    };
    //######################### Life Cycle #########################
    __onPathwayEndUpdated = () => this.forceUpdate();
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state); // call super derive to resolve readonly mode into the state
        return state;
    }
    //######################### Logic #########################
    getPanelClass() {
        return _className(super.getPanelClass(), ModuleFE_EMInterface.isPostDisposition() && 'post-dispo');
    }
    //######################### Render #########################
    renderFooter = undefined;
    renderSubHeader = undefined;
    renderContent = () => undefined;
    renderHeader_Title = () => {
        return _jsx(_Fragment, { children: _jsx(ICONS.advisor_v5_logoWithName.component, {}) });
    };
    renderHeader_Tail = () => {
        return _jsxs(_Fragment, { children: [_jsx(Component_LiveMDMButton, {}), _jsx(Component_EventFeedButton, {})] });
    };
}
//# sourceMappingURL=AdvisorPanel_Settings.js.map